import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { FormBuilder, Validators, FormArray, AbstractControl } from '@angular/forms';
import { UploaderComponent } from '../../components/archivo/uploader/uploader.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { OtComponent } from '../ot/ot.component';
import { CotizacionService } from '../../providers/cotizacion.service';
import { ComunicacionService } from '../../providers/comunicacion.service';
import { ZerosPipe } from '../../pipes/transforms/zeros.pipe';
import { DownloaderComponent } from '../../components/archivo/downloader/downloader.component';
import { PermisoService } from '../../providers/permiso.service';

@Component({
  selector: 'app-orden-venta',
  templateUrl: './orden-venta.component.html',
  styleUrls: ['./orden-venta.component.scss']
})
export class OrdenVentaComponent implements OnInit {
  tipoForm: string = '';
  titulo: string = 'operación de venta';
  cargando: boolean[] = [];
  model: any;
  cotizaciones: any[] = [];
  form = this._fb.group({
    id: [null],
    oc: [null],
    numero: [null],
    tipo_facturacion: [null],
    fecha_operacion_venta: [null],
    transporte: [null],
    ensayos: [null],
    revision: [7],
    observaciones: [null],
    cotizacion_id: [null, Validators.required],
    items: this._fb.array([]),
    archivos: [[]],
  });
  @ViewChild('uploader') uploader: UploaderComponent;
  @ViewChild('downloader') downloader: DownloaderComponent;
  tiposFacturacion: Object[];

  get items() {
    return (this.form.get('items') as FormArray);
  }

  // al menos debe seleccionar un ítem
  itemsValidatorRequired(control: AbstractControl): { [key: string]: boolean } | null {
    const itemControls = (control as FormArray).controls;
    if (itemControls) {
      let i = 0;
      while (i < itemControls.length) {
        // si hay almenos un ítem seleccionado
        if (itemControls[i].get('seleccionado').value) {
          return null;
        }
        i++;
      }
    }
    return {
      'required': true
    };
  }

  constructor(
    private _dialogRef: MatDialogRef<OtComponent>,
    @Inject(MAT_DIALOG_DATA) private _data,
    private _fb: FormBuilder,
    private _cotizacionSv: CotizacionService,
    private _cmSv: ComunicacionService,
    private _zerosPipe: ZerosPipe,
    private _permisoSv: PermisoService,
  ) {
    this._permisoSv.tienePermiso('ORDEN-VENTA-ELIMINAR-ARCHIVOS').then(
      (tienePermiso) => {
        if (tienePermiso) {
          this.downloader.removibles = true;
        }
      }
    );
  }

  ngOnInit() {
    if (!this._data) {
      throw "La variable Input '_data' es requerida";
    }

    if (this._data.model && this._data.model.id) {
      this._prepararModificacion();
    } else {
      this._prepararAlta();
    }

    this._prepararForm();
  }

  private _prepararForm() {
    this.form.get('cotizacion_id').valueChanges.subscribe((cotizacion_id) => {
      const cotizacion = this.cotizaciones.find(cotizacion => cotizacion.IdCotizacion == cotizacion_id);

      if (cotizacion) {
        if (this.tipoForm == 'Crear') {
          // si es "crear" importar las observaciones de venta de la cotización a la operación de venta
          this.form.get('observaciones').setValue(cotizacion.observaciones_venta);
        }
        // listar los ítems de la cotización
        this.form.controls.items = this._fb.array(cotizacion.items.map(item => {
          let seleccionado = false;
          if (this.tipoForm == 'Editar') {
            seleccionado = this.model.items.find(itm => itm.IdCotiItem == item.IdCotiItem) != undefined;
          }
          const itemGroup = this._fb.group({
            item: item,
            seleccionado: { value: seleccionado, disabled: this.tipoForm == 'Editar' },
          });
          itemGroup.get('seleccionado').valueChanges.subscribe(() => {
            setTimeout(() => {
              this.form.updateValueAndValidity();
            }, 250);
          });
          return itemGroup;
        }), this.itemsValidatorRequired);
      } else {
        // no hay cotización seleccionada
        if (this.tipoForm == 'Crear') {
          this.form.get('observaciones').setValue(null);
        }
        this.form.controls.items = this._fb.array([]);
      }
    });

    this._traerCotizaciones();
    this._traerTiposFacturacion();
  }

  private _prepararModificacion() {
    this.tipoForm = 'Editar';
    this.model = this._data.model;
    this.form.get('id').setValue(this.model.id);
    this.form.get('cotizacion_id').setValue(this.model.cotizacion_id);
    this.form.get('cotizacion_id').disable();
    this.form.get('numero').setValue(this.model.numero);
    this.form.get('oc').setValue(this.model.oc);
    this.form.get('observaciones').setValue(this.model.observaciones);
    this.form.get('ensayos').setValue(this.model.ensayos);
    this.form.get('transporte').setValue(this.model.transporte);
    this.form.get('fecha_operacion_venta').setValue(this.model.fecha_operacion_venta);
    this.form.get('tipo_facturacion').setValue(this.model.tipo_facturacion);
    this.form.get('archivos').setValue(this.model.archivos);
    this.form.get('revision').setValue(this.model.revision);
  }

  private _prepararAlta() {
    this.tipoForm = 'Crear';
  }

  private _traerCotizaciones() {
    this.cotizaciones = [];
    this.cargando.push(true);
    this._cotizacionSv.getCotizaciones(
      {
        page: null,
        pageSize: null
      },
      {
        sort: 'numero',
        order: 'desc'
      },
      {
        estadoCotizacion: this._cotizacionSv.ESTADO_VENTA_ACEPTADA
      }
    ).subscribe(
      (respuesta) => {
        this.cargando.pop();
        const data = this._cmSv.format(respuesta, false);
        if (data != this._cmSv.SIN_DATA) {
          this.cotizaciones = data.cotizaciones.map((cotizacion) => {
            const numero = this._zerosPipe.transform(cotizacion.numero, 7);
            return { ...cotizacion, ...{ numero: numero } };
          });
          this.form.get('cotizacion_id').updateValueAndValidity();
        }
      },
      () => {
        this.cargando.pop();
      });
  }

  private _traerTiposFacturacion() {
    this.tiposFacturacion = [];
    this.cargando.push(true);
    this._cotizacionSv.getTiposFacturacion(
      {
        page: null,
        pageSize: null
      },
      {
        sort: null,
        sortOrder: null
      },
      {
        generico: ''
      }
    ).subscribe(
      respuesta => {
        this.cargando.pop();
        const data = this._cmSv.format(respuesta, false);
        if (data != this._cmSv.SIN_DATA) {
          this.tiposFacturacion = data;
        }
      },
      () => {
        this.cargando.pop();
      }
    );
  }

  dismiss() {
    this._dialogRef.close();
  }

  guardado_correctamente: boolean = false;
  submit() {
    this.form.updateValueAndValidity();
    if (this.form.valid) {
      // solo los items seleccioandos enviar
      const items_seleccionados = this.form.get('items').value.filter((element) => element.seleccionado).map(element => element.item);
      this.cargando.push(true);
      // guardar operación de venta
      this._cotizacionSv.guardarOrdenVenta(
        { ...this.form.getRawValue(), ...{ items: items_seleccionados } },
        this.tipoForm.toLowerCase()
      ).subscribe(
        (respuesta) => {
          this.cargando.pop();
          const data = this._cmSv.format(respuesta, false);
          if (data != this._cmSv.SIN_DATA) {
            this.guardado_correctamente = true;
            this.form.get('id').setValue(data.id);
            // con el ID subimos los archivos (si los hay)            
            this.uploader.uploadAll().subscribe(
              (allUploaded) => {
                if (allUploaded) {
                  this._dialogRef.close(this.form.getRawValue());
                } else {
                  // movemos los archivos que si fueron cargados a cargados 
                  // y los removemos de los archivos para cargar
                  this.uploader.getUploadedFiles().forEach((uploadedFile) => {
                    let files = this.form.get('archivos').value;
                    files.push(uploadedFile.data);
                    this.form.get('archivos').setValue(files);
                    this.uploader.remove(uploadedFile);
                  });
                }
              });
          }
        },
        () => {
          this.cargando.pop();
        }
      );
    }
  }

  compareId = (a, b) => {
    return a != null && b != null && typeof a.id != 'undefined' && typeof b.id != 'undefined' && a.id == b.id;
  }
}
